import { requestAPI } from './request';
import i18n from 'i18next';
import { store } from '../store';
import { homescreen } from '../actions';

import { getUserLanguage } from '../../helper/LanguageHelper';

window.__env__ = window.__env__ || {};

export const API = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  BASE_URL: window.__env__.BASE_URL,
  GET_TIME: 'api/v2/current-time',
  VERIFY_CODE: 'api/v2/verify-code',
  API_LOGIN: 'api/v2/social-login',
  API_ADMIN_FORCE_LOGIN: 'api/v2/admin-force-login',
  API_USER_FORCE_LOGIN: 'api/v2/user-force-login',
  //sms login
  API_SMS_SEND_CODE: 'api/v2/send-verification-code',
  API_SMS_VERIFICATION_CODE: 'api/v2/verify-code',
  API_LOGIN_FACEBOOK: 'api/v2/auth/login/facebook',
  API_FACEBOOK_CALLBACK: 'api/v2/facebook/callback',
  API_LOGIN_LINE: 'api/v2/auth/login/line',
  API_LINE_CALLBACK: 'api/v2/line/callback',
  API_WEBHOOK_STRIPE: 'api/v2/webhook/stripe',

  HOME_SCREEN: 'api/v2/home-screen',
  MATCH_DETAIL: 'api/v2/dating/get-matched-details',
  MATCH_PROFILE: 'api/v2/user/match-profile',
  ADD_REQUEST_TIME: 'api/v2/dating/add-request-time',
  UPDATE_REQUEST_TIME: 'api/v2/dating/update-request-time',
  SET_LANGUAGE: 'api/v2/user/set-language',
  SET_PARTICIPATION: 'api/v2/date/participate',
  REFRESH_TOKEN: 'api/v2/generate-token',
  GET_CANCEL_DATING_OPTIONS: 'api/v2/dating/get-cancel-date-options',
  GET_CANCEL_SAMPLE_DATING_OPTIONS:
    'api/v2/participation/get-cancel-sample-date-options',
  CANCEL_DATE: 'api/v2/dating/cancel-date',
  CANCELLED_BY_PARTNER: 'api/v2/dating/cancelled-by-partner',
  PARTICIPATE_REMATCHING: 'api/v2/participation/request-participate-rematch',
  CANCELLED_FOR_REMATCH: 'api/v2/participation/cancel-participate-rematch',
  DEVICE_TOKEN: 'api/v2/user/save-device-token',
  CUSTOMER_SUPPORT: 'api/v2/notify-admin',
  API_PARTICIPATION: 'api/v2/participation',
  DOCUMENT_UPLOAD: 'api/v2/user/upload-required-document',
  API_LOGOUT: '/api/v2/user/logout',
  DELETE_POPUP: '/api/v2/popup-delete',
  CANCEL_DATE_PARTNER: '/api/v2/dating/cancel-date-by-partner',
  GET_BODY_SHAPE: '/api/v2/dating/get-body-shape',
  GET_PREFRENCES: '/api/v2/dating/get-important-preferences',
  FEEDBACK: '/api/v2/feedback',
  // FEEDBACK: '/api/v2/dating/save-feedback-dating',
  FEEDBACK_DETAILS: '/api/v2/feedback/get-feedback-info',
  // FEEDBACK_DETAILS: '/api/v2/dating/feedback-details',
  GET_FEEDBACK: 'api/v2/get-previous-date-data',
  GET_USER_PROFILE: '/api/v2/user/get-profile',
  ACTIVE_PROFILE: '/api/v2/user/active-profile',
  USE_COUPON: '/api/v2/user/use-coupon',
  USE_IMAGE: '/api/v2/user/store-image',
  DETECT_FACE: '/api/v2/google-vision/detect-faces',
  GET_POPUP: '/api/v2/get-popup',
  GET_DEACTIVATE_OPTIONS: 'api/v2/cancelDeactivateOptions',
  GET_CAFE: '/api/v2/dating-place/cafes-at-same-station',
  GET_NOTIFICATIONS: '/api/v2/notifications',
  GET_CHAT_ROOM: '/api/v2/chat/get-room',
  GET_TWILIO_TOKEN: '/api/v2/chat/generate-token',
  // GET_TWILIO_TOKEN: '/api/v2/chat/generate-twilio-token',
  SAVE_CHAT_HISTORY: '/api/v2/chat/handle-after-sending',
  UPDATE_CURSOR: '/api/v2/chat/update-cursor',
  GET_CHAT_MESSAGE: '/api/v2/chat/messages',
  // GET_CHAT_MESSAGE: '/api/v2/twilio/message',
  GET_CHAT_ROOM_V2: '/api/v2/chatkit/getRoomWithPartnerId', // This is API get Chat Room for web app.
  CONFIRM_CHANGE_COST_PLAN: '/api/v2/user/confirm-change-cost-plan',
  CANCEL_CHANGE_COST_PLAN: '/api/v2/user/cancel-change-cost-plan',
  DEACTIVE_PROFILE: '/api/v2/user/deactivate-profile',
  INVITE_FRIENDS: '/api/v2/user/get-user-invitation',
  MATCH_PROFILE_INFO: '/api/v2/get-match-profile-info-data',
  COUPON_LIST: '/api/v2/user/coupon',
  COUPON_PACKAGE: '/api/v2/user/coupon-package',
  EXCHANGE_COUPON: '/api/v2/user/coupon/exchange',
  APPLY_COUPON: '/api/v2/user/coupon/apply',
  EXTEND_TRIAL_BY_TRIAL_SUGGESTION:
    '/api/v2/user/extend-trial-by-trial-suggestion',
  GET_USER_TRIAL_INFO: 'api/v2/user/get-user-trial-info',
  REMATCH: '/api/v2/rematch',
  DATING_REPORT: 'api/v2/dating-report/dating-report-info',
  DATING_HISTORY_REPORT: '/api/v2/dating-report-history',
  DATING: '/api/v2/dating',
  GET_MOTIVATE_IMAGES: 'api/v2/motivate-participation/get-motivate-images',
  //Match info
  MATCH_INFO: '/api/v2/user/match-info',

  //COUPON
  API_COUPON: '/coupon',

  // cancel/deactivation account
  VALIDATE_DEACTIVATE_CANCEL_ACCOUNT:
    '/api/v2/cancel-deactivate/validate-deactivate-cancel-account',
  CANCEL_ACCOUNT: '/api/v2/cancel-deactivate/cancel-account',
  DEACTIVATE_ACCOUNT: '/api/v2/cancel-deactivate/deactivate-account',
  CANCEL_DEACTIVATE_COMPLETE_DATING:
    '/api/v2/cancel-deactivate/completed-dating',
  UPDATE_TEMP_CANCEL_TRIAL:
    '/api/v2/cancel-deactivate/update-temp-cancel-trial',
  GET_CANCEL_DEACTIVE_OPTIONS:
    '/api/v2/cancel-deactivate/get-cancel-deactivate-options',

  //reactive-reapprove-request
  API_REACTIVATE_RE_APPROVE: '/api/v2/user/status/reactive-reapprove-request',
  // re-registration
  API_REREGISTER: '/api/v2/user/status/re-register',
  //registration form
  API_REGISTRATION_FORM: '/api/v2/user/registration',
  API_UPDATE_FIRST_TIME_ACCESS_STEP_EIGHT:
    'api/v2/user/first-access-step-eight-after-approved',
  API_REGISTRATION_FORM_SPECIFIC:
    '/api/v2/user/registration/0/store/specific-step-zero',

  //Profile & preferences
  API_GET_MYPAGE_INFO: '/api/v2/user/get-mypage-info',
  API_GET_PROFILE_INFO: '/api/v2/user/get-profile-info',
  API_GET_PLAN_SUBSCRIPTION: '/api/v2/user/get-plan-subscription',
  API_UPDATE_PROFILE: '/api/v2/user/update-profile',
  API_GET_PREFERENCE: '/api/v2/user/get-preference-info',
  API_UPDATE_PREFERENCE: '/api/v2/user/update-preference',
  API_GET_PREFERRED_AREAS: 'api/v2/user/preferred-areas',
  //Card
  API_CARDS: '/api/v2/user/cards',
  API_STRIPE: 'https://api.stripe.com/v1/',
  // API_STRIPE: 'https://api.stripe.com/v1/tokens'

  //Email Update
  API_UPDATE_EMAIL: '/api/v2/user/update-email',
  API_GET_STOP_NOTIFICATION_CATEGORIES:
    'api/v2/user/get-stop-notification-categories',
  API_STOP_RECEIVE_NOTIFICATION: '/api/v2/user/stop-receive-notification',

  //global current server time
  API_GET_CURRENT_SERVER_TIME: '/api/v2/current-server-time',

  //get dating day able to chat
  GET_DATING_DAY_ABLE_TO_CHAT: '/api/v2/chat/get-chat-dating-day',

  //Plan
  API_PLAN: '/api/v2/user/plan',

  //chat room
  API_ACCESS_CHAT_ROOM: '/api/v2/chat/room',

  //User
  API_GLOBAL_USER: '/api/v2/user',
  API_READ_NOTICE_POPUP: '/api/v2/user/read-notice-popup',
  //Plan
  API_GET_PLAN: '/api/v2/user/plan',
  // Plan Image
  API_GET_IMAGES_PLAN_BY_AGE: '/api/v2/user/get-plan-by-age-images',
  // プランアップデート
  API_CHANGE_PLAN: '/api/v2/user/plan/change/',
  //FB pixel
  API_GET_USER_INFO_FB_PIXEL: '/api/v2/user/get-user-info-for-fb-pixel',
  //GetEmailReservation
  API_GET_EMAIL_RESERVATION: '/api/v2/user/get-email-reservation',
  //Exception
  API_EXCEPTION: '/api/v2/exception',
  //Motivated dating
  API_UPDATE_SEEN_MOTIVATED_DATING: '/api/v2/user/update-seen-motivated-dating',

  //Subscription
  API_SUBSCRIPTION_PAUSED_REQUEST:
    '/api/v2/cancel-deactivate/pause-subscription',
  API_CANCEL_SUBSCRIPTION_PAUSED_REQUEST:
    '/api/v2/cancel-deactivate/cancel-subscription-pause',
  API_GET_SUBSCRIPTION_PAUSE_INFO_FOR_CANCEL:
    '/api/v2/cancel-deactivate/get-subscription-pause-info-for-cancel',

  //change prefecture and area
  API_CHANGE_PREFECTURE_AND_AREA: '/api/v2/user/change-prefecture-and-area',
  API_GET_PREFECTURE_AND_AREA: '/api/v2/user/get-prefecture-and-area',
  API_GET_PREFECTURE_AREA_MASTER: '/api/v2/prefecture-area',
  //commit option
  API_PARTICIPATE_COMMIT_OPTION: 'api/v2/commit-option/request-commit-option',
  CANCEL_COMMIT_OPTION: '/api/v2/commit-option/cancel-commit-option',

  API_REFUND_COMMIT_OPTION: 'api/v2/commit-option/refund-commit-option',

  //Feedback flex question
  API_FEEDBACK_FLEX_QUESTIONS: '/api/v2/feedback/get-available-flex-questions',
  API_FEEDBACK_FIXED_QUESTIONS:
    '/api/v2/feedback/get-available-fixed-questions',

  //USER CERTIFICATION
  GET_USER_CERTIFICATION: '/api/v2/user/certificate',
  UPDATE_USER_CERTIFICATION: '/api/v2/user/certificate/store',
  STORE_IMAGE_USER_CERTIFICATION: '/api/v2/user/certificate/store-image',

  API_GET_NEED_UPDATE_NEW_PREFERENCES:
    '/api/v2/user/get-need-update-new-preferences',

  // V3 Participation APIs
  API_V3_PARTICIPATION_USER_INFO:
    'api/v3/participation/get-participation-user-info',
  API_V3_PARTICIPATION_WEEK: '/api/v3/participation/get-participation-week',
  API_V3_DATING_NEED_FEEDBACK: 'api/v3/participation/get-dating-need-feedback',

  //FACE TYPE
  GET_FACE_TYPE_OPTIONS: '/api/v2/user/get-face-type',
  UPDATE_FACE_TYPE: '/api/v2/user/update-preference',

  // Banner
  STORE_USER_CLICKED_BANNER: '/api/v2/user/banner-click',

  API_GET_NOTICE_POPUP: '/api/v2/user/get-notice-popup',
  API_FIRST_LOGIN_AFTER_APPROVED: '/api/v2/user/first-login-after-approved',

  API_GET_BANNER_SLIDE: '/api/v2/banner/get-banners?deviceType=3',
  // Face_Type
  API_FACE_TYPE_ONE_OPTIONS: 'api/v2/user/get-face-type',
  //user rank
  GET_USER_RANK_INFO: '/api/v2/user-rank/get-info',
  REQUEST_UP_RANK: '/api/v2/user-rank/request-up-rank',
  REQUEST_REMAIN_RANK: '/api/v2/user-rank/request-remain-rank',
  APPROVEED_OR_REJECTED_PROMOTE_RANK:
    '/api/v2/user-rank/approved-or-rejected-promote-rank',

  //USER PARTICIPATION ITEMS
  GET_PARTICIPATION_ITEMS: '/api/v2/beta-item/get-participation-item',
  UPDATE_USER_PARTICIPATION_ITEMS:
    '/api/v2/beta-item/select-participation-item',
  PURCHASE_DATING_ITEMS: '/api/v2/beta-item/purchase-participation-item',
  GET_USER_PARTICIPATION_ITEMS: '/api/v2/user/participation-items',
  UPDATE_USER_PARTICIPATION_ITEMS_STATUS:
    '/api/v2/beta-item/request-participation-item',
  //New social login
  API_SOCIAL_AUTH_VERIFY_PHONE: 'api/v2/social-auth/verify-phone',
  API_SOCIAL_AUTH_VERIFY_PHONE_CODE: 'api/v2/social-auth/verify-phone-code',

  // INVOICE
  RENEW_EXPIRED_INVOICE: '/api/v2/user/renew-expired-invoice'
};

export const requestSetLanguage = (params, timeout) =>
  requestAPI(API.SET_LANGUAGE, API.POST, params, timeout);

export const requestHomeScreen = () => {
  const i18nMap = {
    1: 'en',
    2: 'jp'
  };

  const languageId = getUserLanguage();

  const homescreenAction = homescreen({}, () => {
    i18n.changeLanguage(i18nMap[languageId]);
  });
  store.dispatch(homescreenAction);
};
